

































import {Component, Vue} from 'vue-property-decorator';
import CompanyForm from '@/components/Company/CompanyForm.vue';
import CompanySettingsForm from '@/components/Company/CompanySettingsForm.vue';
import ICompanyInfo from '@/types/ICompanyInfo';
import CompanyService from '@/services/CompanyService';
import { resolveError } from '@/utils/notifications';

@Component({
  name: 'Company',
  components: {CompanySettingsForm, CompanyForm}
})
export default class Company extends Vue {
  companyData: ICompanyInfo | null = null

  constructor() {
    super()
    this.fetchData()
  }

  async fetchData() {
    try {
      this.companyData = await CompanyService.getCompanyInfo()
    } catch (e) {
      resolveError(e, 'fetch_data')
    }
  }
}
